module.exports = __webpack_public_path__ + "img/logo.4ff6a426.png";